// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"toggle-module__toggleContainer--1vTqy","switch":"toggle-module__switch--3rfx-","slider":"toggle-module__slider--klSbj"};